import { render, staticRenderFns } from "./domainButton.vue?vue&type=template&id=28c0d97c"
import script from "./domainButton.vue?vue&type=script&lang=ts"
export * from "./domainButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports